import styled from 'styled-components';

const Wrap = styled.div`
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px;
  width: 383px;

  &:after {
    position: absolute;
    content: '';
    top: 1px;
    left: 50%;
    margin-left: -7px;
    height: 8px;
    width: 14px;
    background: #3e454d;
    clip-path: polygon(50% 0, 100% 100%, 0 100%);
  }
`;

const Inner = styled.div`
  box-sizing: border-box;
  //width: 383px;
  border-radius: 4px;
  padding: 4px;
  //background-color:#27303A ;
  background: #3e454d;
`;

const StyledTitle = styled.div`
  padding: 4px 12px 0;
  height: 38px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: var(--fs-md);
  font-weight: 500;
  color: #fff;

  .iconfont {
    color: #d7d7d7;
    cursor: pointer;
    font-size: var(--fs-lg);
    margin-left: 10px;
  }
`;

const StyledBody = styled.div`
  //height: 520px;
`;

const Title = (props) => {
  return (
    <StyledTitle>
      <span>{}</span>
    </StyledTitle>
  );
};

const Popup = (props) => {
  const { title, children, position = '', style, className = '' } = props;

  return (
    <Wrap className={className + ' ' + position + ' _popup'} style={style}>
      <Inner>
        <StyledTitle>{title}</StyledTitle>
        <StyledBody>{children}</StyledBody>
      </Inner>
    </Wrap>
  );
};

export default Popup;
